// extracted by mini-css-extract-plugin
export default {"verticalGapContainer":"FullNameField-module--verticalGapContainer--ZlXFf","horizontalGapContainer":"FullNameField-module--horizontalGapContainer--VMVPn"};